module.exports = "/_next/static/images/join-telegram-pt-br-def25e11ea2025a70a03ce02365b8ace.png";